export default __webpack_public_path__ + "static/media/grandmamaWhite.56488169.png";